module.exports = __webpack_public_path__ + "static/media/speaker-luo-mobile.fb26bd8d.jpg";